import { useEffect, useState } from "react";
import { usePageNameContext } from "../../../contexts/PageTitleContext";
import { ICategorySearchTerm } from "../../../models/Category/Category";
import { createColumnHelper } from "@tanstack/react-table";
import { ArrowUpTrayIcon, CheckCircleIcon, PencilIcon } from "@heroicons/react/24/outline";
import { Table } from "../../../components/base/Table/Table";
import { CategorySearchTermQueryKeys } from "../../../data/Category/keys";
import CategorySearchTermModal from "../../../components/Scrape/CategorySearchTermModal";
import { set } from "react-hook-form";
import Breadcrumbs from "../../../components/shared/Breadcrumbs/Breadcrumbs";
import { useNavigate } from "react-router-dom";

export default function SearchTermsPage() {
    const { setInfo } = usePageNameContext();
    const navigate = useNavigate();

    const [selectedTerm, setSelectedTerm] = useState<ICategorySearchTerm | undefined>(undefined);
    const [editOpen, setEditOpen] = useState<boolean>(false);

    const colHelper = createColumnHelper<ICategorySearchTerm>();

    const cols = [
        // colHelper.accessor("title", { header: "Title" }),
        colHelper.accessor("categoryName", {
            header: "Category Name",
            cell: (info) => (
                <div className="max-w-xl text-wrap truncate" title={info.getValue() ?? ""}>
                    {info.getValue()}
                </div>
            )
        }),
        colHelper.accessor("include", {
            header: "Include",
            cell: (info) => {
                return (
                    <div className="max-w-96 text-wrap" title={info.getValue() ?? ""}>
                        {info.getValue()}
                    </div>
                )
            }
        }),
        colHelper.accessor("exclude", {
            header: "Exclude",
            cell: (info) => (
                <div className="max-w-96 text-wrap" title={info.getValue() ?? ""}>
                    {info.getValue()}
                </div>
            )
        }),
        colHelper.accessor("totalParts", {
            header: "Total Assigned Parts",
            cell: (info) => (
                <div className="max-w-xl text-wrap">
                    {info.getValue()}
                </div>
            )
        }),
        colHelper.accessor("totalPrice", {
            header: "Total Price",
            cell: (info) => (
                <div className="max-w-xl text-wrap">
                    £{info.getValue().toLocaleString()}
                </div>
            )
        }),
        colHelper.accessor("averagePrice", {
            header: "Average Price",
            cell: (info) => (
                <div className="max-w-xl text-wrap">
                    £{info.getValue().toLocaleString()}
                </div>
            )
        }),
        colHelper.display({
            header: "Actions",
            cell: (info) => {
                const term = info.row.original;

                return (
                    <div className="flex items-center space-x-4">
                        <PencilIcon
                            className="w-5 h-5 opacity-70 hover:opacity-100 hover:cursor-pointer"
                            onClick={() => {
                                setSelectedTerm(term);
                                setEditOpen(true);
                            }}
                        />
                        <ArrowUpTrayIcon
                            className="w-5 h-5 opacity-70 hover:opacity-100 hover:cursor-pointer"
                            onClick={() => {
                                navigate("/scrape?categorySearchTermId=" + term.id + "&categoryId=" + term.categoryId);
                            }}
                        />
                        {/* <TrashIcon
                            className="w-5 h-5 opacity-70 hover:opacity-100 hover:cursor-pointer"
                            onClick={() => { setDeleteId(part.id); setDeleteOpen(true); }}
                        /> */}
                    </div>
                );
            },
        }),
    ];

    useEffect(() => {
        setInfo({
            name: "Part Editor",
            desc: "View and edit your parts here",
            pageTitle: "Parts",
        });
    }, []);


    return (
        <>
            <Breadcrumbs pages={[
                { label: "Scrape Data", to: "/scrape" },
            ]} />
            <div className="flex flex-col space-y-4">
                <CategorySearchTermModal 
                    open={editOpen} 
                    setOpen={setEditOpen} 
                    searchTerm={selectedTerm}
                />
                <Table
                    url="/part/category/terms/paginated"
                    queryKey={CategorySearchTermQueryKeys.all()}
                    columns={cols}
                    // searchLabel="Search by vin or part number"
                    // externalFilters={{
                    //     hideCategorised: hideCategorised,
                    //     hideAccepted: hideAccepted,
                    //     include: include,
                    //     exclude: exclude,
                    // }}
                    // bulkActions={[
                    //     {
                    //         label: "Set Category",
                    //         onClick: handleBulkSetCategory,
                    //     },
                    //     {
                    //         label: "Archive",
                    //         onClick: (parts: IEbayPart[]) => {
                    //             setToArchive(parts.map((p) => p.id));
                    //             setArchiveOpen(true);
                    //         },
                    //     }
                    // ]}
                />
            </div>
        </>
    )
}